import type { GoalPortfolioResponseDTO } from "web_myplann/Infrastructure/Api/Api";

export type GoalPortfolioWithId = GoalPortfolioResponseDTO & {
	portfolioId: number;
};

export const hasPortfolioId = (
	portfolio: GoalPortfolioResponseDTO,
): portfolio is GoalPortfolioWithId => portfolio.portfolioId != null;
